var _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplayAppTour(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7857 5.11597C16.7857 7.76622 13.8456 10.5263 12.8583 11.3788C12.7663 11.448 12.6544 11.4854 12.5393 11.4854C12.4242 11.4854 12.3123 11.448 12.2203 11.3788C11.233 10.5263 8.29297 7.76622 8.29297 5.11597C8.29297 3.98977 8.74035 2.9097 9.53669 2.11335C10.333 1.31701 11.4131 0.869629 12.5393 0.869629C13.6655 0.869629 14.7456 1.31701 15.5419 2.11335C16.3383 2.9097 16.7857 3.98977 16.7857 5.11597Z",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5416 6.70917C13.421 6.70917 14.134 5.99624 14.134 5.11679C14.134 4.23735 13.421 3.52441 12.5416 3.52441C11.6622 3.52441 10.9492 4.23735 10.9492 5.11679C10.9492 5.99624 11.6622 6.70917 12.5416 6.70917Z",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2141 11.4854H6.15317C5.51147 11.4854 4.99128 12.0055 4.99128 12.6472V12.6472C4.99128 13.2889 5.51147 13.8091 6.15316 13.8091H10.595C11.2463 13.8091 11.7743 14.3371 11.7743 14.9884V14.9884C11.7743 15.6397 11.2463 16.1677 10.595 16.1677H4.98047",
    stroke: "#67768E",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.69678,
    cy: 16.042,
    r: 1.07412,
    stroke: "#67768E",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplayAppTour);
export default __webpack_public_path__ + "static/media/replayAppTour.d9c7ee087cc42696a373004a24bddd4c.svg";
export { ForwardRef as ReactComponent };